import { useQuery } from '@tanstack/react-query'
import { fileSrc } from './FileLoader'
import { useMemo } from 'react'
import { get_request_api } from '@velocity/shared'

export const LetterHead = () => {
  const setting = JSON.parse(localStorage.getItem('settings') || '{}')
  const { data: r_setting } = useQuery({
    queryKey: ['settings'],
    queryFn: get_request_api,
    enabled: !setting?.letter_head
  })
  const settings = useMemo(() => {
    return r_setting || setting
  }, [r_setting, setting])
  return settings?.letter_head ?
      <img
        src={fileSrc({
          id: settings.letter_head,
          provider: 'cloudinary'
        })}
        alt='Letter Head'
        className='border-b mb-2'
      />
    : null
}
export const AltLetterHead = ({ show }: { show?: boolean }) => {
  const setting = JSON.parse(localStorage.getItem('settings') || '{}')
  const { data: r_setting } = useQuery({
    queryKey: ['settings'],
    queryFn: get_request_api,
    enabled: !setting?.letter_head
  })
  const settings = useMemo(() => {
    return r_setting || setting
  }, [r_setting, setting])
  return !settings?.letter_head || show ?
      <div className='text-xl font-semibold'>
        {settings?.business_logo && (
          <img
            className='w-[6rem] object-contain'
            src={fileSrc({
              id: settings.business_logo,
              provider: 'cloudinary'
            })}
            alt=''
          />
        )}
        <p className='text-[14px]'>{settings?.business_name}</p>
        <div className='font-[500] text-[14px] mb-2'>
          <p>{settings?.address}</p>
        </div>
      </div>
    : null
}
